import React from 'react';
import { Spin } from 'antd';

import './Spinner.scss';

export default function Spinner() {
  return (
    <div className="Spinner--container">
      <Spin size="large" />
    </div>
  );
}
